import { render } from "./IntercomAttachmentLink.vue?vue&type=template&id=68ee8f23"
import script from "./IntercomAttachmentLink.vue?vue&type=script&lang=js"
export * from "./IntercomAttachmentLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__